var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "),_c('b-loading',{staticClass:"app-loader",attrs:{"active":_vm.loaderIsActive}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }